<template>
  <div class="auth__wrapper">
    <div class="auth__overlay">
      <div class="auth__inner-wrapper">
        <div class="auth__logo">
          <img :src="CampaignLogo" title="logo" />
          <h1>{{ title }}</h1>
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

import CampaignLogo from "@/assets/images/campaign_logo.svg";

export default Vue.component("AuthLayout", {
  props: {
    title: VueTypes.string
  },

  data() {
    return {
      CampaignLogo
    };
  }
});
</script>

<style lang="scss" scoped>
$ns: "auth";
.#{$ns} {
  &__wrapper {
    width: 100%;
    height: 100%;
  }

  &__overlay {
    display: flex;
    align-items: center;
    position: relative;
    min-height: 100%;
    background: url("../assets/images/mask.svg") no-repeat 100% 100%;
    background-size: cover;
  }

  &__inner-wrapper {
    min-height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 50px 0;

    h1 {
      font-size: 24px;
      margin: 20px;
    }
  }

  &__logo {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    img {
      width: 106px;
    }
  }
}

@media screen and (max-width: 900px) {
  .#{$ns} {
    &__overlay {
      max-width: 100%;
    }
  }
}
</style>
